import _classCallCheck from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
/**
 * Error thrown on an axios response if the response can be mapped to a safe error.
 * A SafeApiError has a `message` which is mapped from a `help` message on the raw response
 * and is safe to show the user.
 */
var SafeApiError = /*#__PURE__*/function (_Error) {
  function SafeApiError(help, errorMessage, details, errorCode, response, axiosError) {
    var _this;
    _classCallCheck(this, SafeApiError);
    _this = _callSuper(this, SafeApiError, [help]);
    _this.name = ''; // sets to empty string to avoid is being prepended to the message
    _this.type = 'SafeApiError';
    _this.errorMessage = errorMessage;
    _this.details = details;
    _this.errorCode = errorCode;
    _this.response = response; // set the raw response for backwards compatibility with an AxiosError
    _this.axiosError = axiosError;
    return _this;
  }
  _inherits(SafeApiError, _Error);
  return _createClass(SafeApiError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        type: this.type,
        message: this.message,
        errorMessage: this.errorMessage,
        details: this.details,
        errorCode: this.errorCode
      };
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { SafeApiError };